import {
  FLOATING_EXPANDABLE_BUBBLE_MARGIN,
  FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH
} from "PFComponents/floating_expandable_bubble/constants";
import type { BubblePosition } from "PFComponents/floating_expandable_bubble/types";

export const PROPILOT_REGION_ID = "propilot_region";

export const PROPILOT_BUBBLE_Z_INDEX = 2800;

export const PROPILOT_PANEL_Z_INDEX = 3000;

export const PROPILOT_BUBBLE_MARGIN = 24;

export const PROPILOT_BUBBLE_SIZE = 48;

export const PROPILOT_PANEL_WIDTH = 461;

export const PROPILOT_PANEL_HEIGHT = 570;

export const PROPILOT_PANEL_MIN_WIDTH = 280;

export const PROPILOT_PANEL_MIN_HEIGHT = 300;

export const BUBBLE_POSITION_STORAGE_KEY = "pro_pilot_bubble_position";

export const NAVBAR_DOCK_ZONE_ID = "navbar-dock";

export const PROPILOT_DEFAULT_POSITION: BubblePosition = {
  horizontal: {
    type: "start",
    offset: FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH + FLOATING_EXPANDABLE_BUBBLE_MARGIN
  },
  vertical: { type: "end", offset: FLOATING_EXPANDABLE_BUBBLE_MARGIN }
};

export const NAVBAR_DOCK_ZONE_HEIGHT = 120;
